import { render, staticRenderFns } from "./ConfiguracaoPagamento.vue?vue&type=template&id=04c0d7e2&lang=html&"
import script from "./ConfiguracaoPagamento.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoPagamento.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoPagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoPagamento.vue
// module id = 1158
// module chunks = 28